<template>
  <span>
    <!-- <el-button size="small" type="primary" @click="openDialog">添加</el-button> -->
    <el-dialog
      title="选择区域"
      v-if="relateDeviceFlag"
      :visible.sync="relateDeviceFlag"
      append-to-body="true"
      width="80%"
      :before-close="handleClose"
    >
      <avue-crud
        v-if="crudVisible"
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :search.sync="selectForm"
        ref="crud"
        @current-change="currentChange"
        @size-change="sizeChange"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @on-load="onLoad"
        @refresh-change="onLoad"
      >
      <template slot="choice" slot-scope="scope">
        <el-radio v-model="radio" :label="scope.row"> {{ ' ' }}</el-radio>
      </template>
      
      </avue-crud>
       <div class="btnArea" style="text-align:right;">
      <el-button size="small" type="primary" icon="el-icon-circle-plus-outline" @click="submitData"
        >提交</el-button
      >
      <el-button
        size="small"
        icon="el-icon-circle-close"
        style="margin-right:24px"
        @click="cancelOperate"
        >取消</el-button
      >
    </div>
    </el-dialog>
  </span>
</template>

<script>
import { treeByProjectDeptId } from '@/api/crmedical/device/device';
import { getList } from '@/api/crmedical/project/area.js';
export default {
  props: {
    projectId: {
      type: String,
      default: '',
    },
    taskContentData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      crudVisible:false,
            radio:{},
      loading: false,
      relateDeviceFlag: false,
      relateAllDeviceForm: {},
      data: [],
      selectForm: {
        projectId: '',
        name: '',
        code: '',
        deptId: '',
      },
      treeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      areaTreeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      showDetpTree: false,
      treeFormAreaData: [], //所属区域
      treeFormDeptData: [], //所属科室
      treeFormData: [], //设备类型
      deviceList: [],
      option: {
        indexLabel: '序号',
        tip: false,
        menu: false,
        border: true,
        index: true,
        selection: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        columnBtn: false,
        searchMenuSpan: 6,
        searchMenuPosition: 'right',
        column: [
          {
            label: '选择',
            prop: 'choice',
            slot: true,
            align: 'center',
          },
          {
            label: '区域编号',
            prop: 'code',
            maxlength: 20,
            showWordLimit: true,
            search: true,
          },
          {
            label: '区域名称',
            prop: 'name',
            maxlength: 20,
            showWordLimit: true,
            search: true,
          },
          {
            label: '区域全称',
            prop: 'fullName',
          },
          {
            label: '所属科室',
            prop: 'deptId',
            type: 'tree',
            search: true,
            dicUrl: `/api/v4ward/dept/treeByProjectDeptId?projectId=${this.projectId}`,
            props: { label: 'title', value: 'key' },
          },
        ],
      },
      selectionData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
    };
  },
  created() {
    // this.initData();
    this.openDialog()
  },
  methods: {
    handleClose(){
      this.$emit("close")
    },
    // 打开弹窗
    openDialog() {
      if (this.projectId) {
        this.relateDeviceFlag = true;
        this.selectForm.projectId = this.projectId;
                this.crudVisible = false
        setTimeout(()=>{
           this.crudVisible = true
        this.radio = {}
        this.initData();
        })
       
      } else {
        this.$message({
          message: '请先选择【项目名称】！',
          type: 'warning',
        });
        return;
      }
    },
    // 清空科室
    deptClear() {
      this.selectForm.deptName = '';
      this.selectForm.deptId = '';
    },

    // 清空
    searchClear() {
      this.selectForm = {};
      this.selectForm.projectId = this.projectId;
    },
    submitData(){
            console.log('ddd',this.radio)
            if(this.radio.id){
                    this.$emit('getArea', this.radio);
                    this.relateDeviceFlag = false;
                      this.$emit("close")
            }else{
                  this.$message({
          message: '请先选择区域！',
          type: 'warning',
        });
            }
            
    },
    cancelOperate(){
            this.relateDeviceFlag = false;
              this.$emit("close")
    },
    // 添加已选择数据
    relateChoiceDevice() {
      this.loading = true;
      let temArr = [];
      let selectedIds = [];
      this.taskContentData.forEach((ele) => {
        temArr.push(ele);
        selectedIds.push(ele.id);
      });
      this.selectionData.forEach((ele) => {
        if (selectedIds.indexOf(ele.id) < 0) {
          temArr.push(ele);
        }
      });
      this.$emit('getArea', temArr);
      this.loading = false;
      this.relateDeviceFlag = false;
    },

    // 选择的数据
    selectionChange(val) {
      this.selectionData = val;
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.deviceIds = Ids.join(',');
    },
    search() {
      this.page.currentPage = 1;
      this.radio = {}
      this.onLoad();
    },
    
    searchChange(params, done) {
      console.log("shousuo")
      this.radio = {}//重置选中区域
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },

    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    // 获取列表数据
    onLoad() {
      let page = page || this.page;
      this.loading = true;
      this.selectForm.projectId = this.projectId;
      console.log(this.selectForm);
      this.relateAllDeviceForm = Object.assign({}, this.selectForm);

      getList(
        Object.assign({ current: this.page.currentPage, size: this.page.pageSize }, this.selectForm)
      ).then(({ data }) => {
        this.data = data.records;
        this.page.total = data.total;
        this.loading = false;
      });
    },
    initData() {},

    treeByProjectDeptId(value) {
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.treeFormDeptData = res.data;
      });
    },
    handleDeptNodeClick(node) {
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.deptName = nodeTitle;
      this.selectForm.deptId = nodeId;
      console.log(node);
    },
  },
};
</script>

<style></style>
